// Error Types for VRP Unified Architecture
export enum VRPErrorCategory {
  // Context and State Errors
  CONTEXT_ERROR = 'CONTEXT_ERROR',
  STATE_MANAGEMENT_ERROR = 'STATE_MANAGEMENT_ERROR',
  
  // Navigation and Routing Errors
  NAVIGATION_ERROR = 'NAVIGATION_ERROR',
  ROUTE_ERROR = 'ROUTE_ERROR',
  
  // Data and API Errors
  API_ERROR = 'API_ERROR',
  DATA_VALIDATION_ERROR = 'DATA_VALIDATION_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  
  // UI and Component Errors
  COMPONENT_ERROR = 'COMPONENT_ERROR',
  RENDER_ERROR = 'RENDER_ERROR',
  
  // System and Performance Errors
  PERFORMANCE_ERROR = 'PERFORMANCE_ERROR',
  MEMORY_ERROR = 'MEMORY_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  
  // User and Permission Errors
  PERMISSION_ERROR = 'PERMISSION_ERROR',
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  
  // Unknown Errors
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export enum VRPErrorSeverity {
  LOW = 'LOW',       // Minor issues, app continues normally
  MEDIUM = 'MEDIUM', // Noticeable issues, some features affected
  HIGH = 'HIGH',     // Major issues, significant functionality impacted
  CRITICAL = 'CRITICAL' // Critical issues, app may be unusable
}

export interface VRPError {
  id: string;
  category: VRPErrorCategory;
  severity: VRPErrorSeverity;
  message: string;
  originalError?: Error;
  context: {
    userId?: string;
    route: string;
    timestamp: number;
    userAgent: string;
    sessionId: string;
    projectId?: number;
    scenarioId?: number;
    datasetId?: number;
    feature?: string;
    component?: string;
    stack?: string;
  };
  metadata?: Record<string, any>;
  recovered: boolean;
  recoveryMethod?: string;
  retryCount?: number;
}

export interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
  errorId: string | null;
  retryCount: number;
}

export interface ErrorRecoveryOptions {
  maxRetries?: number;
  retryDelay?: number;
  fallbackComponent?: React.ComponentType<any>;
  onRecovery?: (error: VRPError) => void;
  onMaxRetriesReached?: (error: VRPError) => void;
}

export interface ErrorReportingConfig {
  enabled: boolean;
  endpoint?: string;
  apiKey?: string;
  sampleRate?: number;
  enableConsoleLogging?: boolean;
  enableLocalStorage?: boolean;
  maxStoredErrors?: number;
}